import * as React from 'react'
import { styled } from '@mui/system'
import { useGetStockList } from '../../api/stock'

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
}

const Root = styled('div')(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    text-align: left;
    padding: 6px;
  }

  th {
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : grey[100]};
  }
  `
)

export const StockTable = (props) => {
  const { department, classification, itemId } = props

  const stockListRes = useGetStockList({
    department: department,
    classification: classification,
    itemId: itemId,
  })

  const stockData = stockListRes?.data ?? []
  return (
    <Root sx={{ width: 500, maxWidth: '100%' }}>
      <table aria-label='stock-table'>
        <thead>
          <tr>
            <th>Site</th>
            <th>Unit</th>
            <th>Stock</th>
            <th>Reserved</th>
            <th>Ordered</th>
          </tr>
        </thead>
        <tbody>
          {stockData?.map((row, idx) => (
            <tr key={idx}>
              <td>{row.site}</td>
              <td style={{ width: 120 }} align='right'>
                {row.unit}
              </td>
              <td style={{ width: 120 }} align='right'>
                {row.stock}
              </td>
              <td style={{ width: 120 }} align='right'>
                {row.reserved}
              </td>
              <td style={{ width: 120 }} align='right'>
                {row.ordered}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Root>
  )
}
